import axios from 'axios'
import { setupCache } from 'axios-cache-interceptor'

/** Default cache lifetime (ms). Short: just long enough to dedupe same-board calls on load. */
export const DEFAULT_TTL = 3000

/**
 * Shared cached axios instance. Identical requests within the TTL share one
 * response, so duplicate same-board calls (e.g. Vuex + Vue Query) collapse into
 * a single network request.
 *
 *
 * @see {@link https://axios-cache-interceptor.js.org/ | axios-cache-interceptor docs}
 * @example axiosCacheClient.get(url, { headers: getAuthHeader() })          // default TTL
 * @example axiosCacheClient.get(url, { cache: { ttl: 10000 } })             // custom TTL
 * @example axiosCacheClient.get(url, { cache: false })                      // skip cache
 * @example axiosCacheClient.get(url, { cache: { override: true } })         // force fresh + refresh cache
 */
export const axiosCacheClient = setupCache(axios.create(), {
  ttl: DEFAULT_TTL,
  interpretHeader: false,
  methods: ['get']
})

// This is to handle cases where URL objects are passed instead of strings.
// The lib only supports string url.
axiosCacheClient.interceptors.request.use((config) => {
  if (config.url instanceof URL) {
    config.url = config.url.toString()
  }
  return config
})
